import React from 'react';
import NavItem from "../../Nav/NavItem";
import NavLink from "../../Nav/NavLink";

var NavLabel = function NavLabel(_ref) {
  var selected = _ref.selected,
      label = _ref.label,
      onClick = _ref.onClick,
      visible = _ref.visible;
  return /*#__PURE__*/React.createElement(NavItem, {
    className: !visible ? 'invisible' : '',
    "data-testid": "monthcalendar-navitem"
  }, /*#__PURE__*/React.createElement(NavLink, {
    active: selected,
    className: "text-center py-1 px-2",
    color: "primary",
    onClick: onClick,
    style: {
      cursor: 'pointer',
      listStyle: 'none'
    }
  }, label));
};

NavLabel.displayName = "NavLabel";
export default NavLabel;